module.exports = __webpack_public_path__ + "static/media/avery.9b73f1ff.jpeg";